'use client';

import { createContext, useContext } from 'react';

type ResponsiveModalContextType = {
  isDesktop: boolean;
};

export const ResponsiveModalContext = createContext<ResponsiveModalContextType | undefined>(
  undefined,
);

export const useResponsiveModalContext = () => {
  const context = useContext(ResponsiveModalContext);
  if (!context) {
    throw new Error('useResponsiveModalContext must be used within ResponsiveModal');
  }
  return context;
};
